<template>
  <div class="page-content" :style="defaultHeight">
    <div class="startTitle">我的签到</div>
    <el-row>
      <div class="zSign-Wrap">
        <div class="zSign-Head">
          <i class="zSign-HeadIcon"></i>
          <h5>签到成功，获得<em>5</em>积分</h5>
          <p>总积分<em>135</em></p>
          <p>已连续签到<em class="zSign-Day">2</em>天，继续加油！</p>
        </div>
        <div class="zSign-List">
          <ul>
            <li class="active">
              <h5>第一天</h5>
              <i class=""></i>
              <em>5积分</em>
            </li>
            <li class="past">
              <h5>第二天</h5>
              <i class=""></i>
              <em>5积分</em>
            </li>
            <li class="active">
              <h5>第三天</h5>
              <i class=""></i>
              <em>5积分</em>
            </li>
            <li class="">
              <h5>第四天</h5>
              <i class=""></i>
              <em>5积分</em>
            </li>
            <li class="">
              <h5>第五天</h5>
              <i class=""></i>
              <em>5积分</em>
            </li>
            <li class="">
              <h5>第六天</h5>
              <i class=""></i>
              <em>5积分</em>
            </li>
            <li class="">
              <h5>第七天</h5>
              <i class=""></i>
              <em>15积分</em>
            </li>
          </ul>
        </div>
        <div class="zSign-More">您还有<em>6</em>个积分任务待完成，<a href="#">查看详情</a></div>
        <div class="zSign-Btn">
          <el-button type="info" class="" @click="toPage()">积分兑换</el-button>
        </div>
      </div>
    </el-row>
     <!-- 弹出框 积分兑换 -->
    <el-dialog :visible.sync="open" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">

            <img class='codewrapImg' src='@/assets/images/app_coder2.png'/>
            <div class='codewrapdiv' >为了您更便捷的使用积分兑换功能以及参与体验积分任务</div>
            <div class='codewrapdiv' >请您使用吾征AI健康APP或微信公众号获得更多积分奖励</div>
            <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
            <div style='padding-bottom: 40px;'>
                <div class="codewrap2" >
                  <img src="@/assets/images/app_coder.png">
                  <p>吾征AI健康APP</p>
                  <p>扫码下载</p>
                </div>
                <div class="codewrap2">
                  <img src="@/assets/images/weixin_coder.png">
                  <p>吾征AI公众号</p>
                  <p>扫码关注</p>
                </div>
            </div>
        <!-- 关注公众号 -->
        <div id="alertwarp">
          <div id="alertmask"></div>
          <div id="alertwx">
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import { mechanismSettleIn } from '@/api/myInfo'
export default {
  name: "signrecord",
  data () {
    return {
       open: false,
      defaultHeight: {
        height: ""
      },
      userId: this.$store.state.user.info
    }
  },
  components: {},
  mounted () {
    // this.queryRealById();
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    //弹出积分
    toPage(){
      this.open = true;
  }
  },

}
</script>
<style scoped>
.zSign-Wrap {
  margin-top: 90px;
  text-align: center;
}
.el-dialog__body{
  padding-top: 0;
}
.codewrap2 {
  display: inline-block;
  width: 100px;
  margin-right:70px;
  margin-left:70px;
  text-align: center;
}
.codewrap2 img {
  padding-bottom: 10px;
  /* margin-top: 40px; */
}
.codewrap2 p {
  width: 100%;
  height: 22px;
  line-height: 22px;
   /* margin-bottom: 20px; */
}
.codewrapImg{

  width: 128px;
  height: 128px;
  margin-bottom: 50px;
}
.codewrapdiv{
  height: 15px;
  color:#000000;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.codewrapdiv2{
  height: 15px;
  color:#666;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 45px;
}
.zSign-HeadIcon {
  display: inline-block;
  width: 80px;
  height: 80px;
  background: url(../../assets/images/back/CheckInIconDate.png) no-repeat center;
}
.zSign-Head p {
  color: #666;
}
.zSign-Head .zSign-Day {
  padding: 0 5px;
  color: #ff5454;
  font-weight: bold;
}
.zSign-Head h5 {
  font-size: 28px;
  padding: 10px 0;
  color: #000;
  font-weight: bold;
}
.zSign-Head h5 em {
  padding: 0 5px;
  color: #ff5454;
}
.zSign-Head p {
  padding: 5px 0;
  font-size: 15px;
}
.zSign-List {
  margin: 50px auto;
}
.zSign-List ul {
  display: flex;
  justify-content: center;
}
.zSign-List ul li {
  background: #fff;
  border: 1px solid #fff;
  width: 100px;
  height: 120px;
  margin: 0 12px;
  box-shadow: #f0f0f0 0px 0px 15px 5px;
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  position: relative;
}
.zSign-List ul li h5 {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  font-weight: bold;
}
.zSign-List ul li i {
  width: 32px;
  height: 32px;
  position: absolute;
  left: 50%;
  margin-left: -16px;
  top: 44px;
  background: url(../../assets/images/back/CheckInIcon.png) no-repeat -64px center;
}
.zSign-List ul .active {
  background: #fcab0f;
  border-color: #fcab0f;
  box-shadow: none;
}
.zSign-List ul .active h5,
.zSign-List ul .active em {
  color: #fff;
}
.zSign-List ul .active i {
  background-position: left center;
}
.zSign-List ul .past {
  background: #fafafa;
  border-color: #e6e6e6;
  box-shadow: none;
}
.zSign-List ul .past i {
  background-position: -32px center;
}
.zSign-List ul .past h5,
.zSign-List ul .past em {
  color: #999;
}
.zSign-List ul li em {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #666;
  font-size: 15px;
}
.zSign-More {
  font-size: 15px;
  padding-bottom: 20px;
  color: #666;
}
.zSign-More em {
  padding: 0 5px;
  color: #14c86c;
  font-weight: bold;
}
.zSign-More a {
  color: #14c86c;

  text-decoration: underline;
}
.zSign-Btn .el-button {
  width: 160px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  background: #14c86c;
  border-color: #14c86c;
}
.zSign-Btn .el-button:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/signrecord.vue